import Pagination from "components/pagination";
import { Breadcrumbs } from "components/breadcrumbs";
import { useTable, useUpdate } from "@refinedev/core";
import { IConditionItem } from "interfaces";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { ConditionCard, ConditionTable } from "./components";
import { isHaveActionPermission } from "utills/helpers";

export const AboutActiupList: React.FC = () => {
  const {
    tableQueryResult,
    filters,
    setFilters,
  } = useTable<IConditionItem>({
    resource: "content/about-us",
    syncWithLocation: true,
    pagination: {
      mode: "off"
    },
    meta: {
      resource: "data",
    },
  });

  const { mutate: updateMutation, isLoading: updateMutationIsLoading } = useUpdate();

  const _toggleActive = (id: string, isActive: boolean) => {
    if (!isHaveActionPermission("about_actiup", "other", "edit")) return;
    if (window.confirm(`Are you sure you want to ${isActive ? "deactivate" : "activate"}  this Condition?`)) {
      updateMutation({
        resource: "content/about-us",
        id,
        meta: {
          URLSuffix: `active/${!isActive}`,
          ignoreResourceWrapper: true
        },
        values: {},
      },
      {
        onSuccess: () => {
          toast.success("Update successfully");
        },
      });
    }
  };

  const _handlePageChanged = (page: number) => {
    const updatedFilters = [...filters].flatMap(item => "field" in item ? item: []);
    const pageIndex = updatedFilters.findIndex(filter => filter.field === "page");
    if (pageIndex < 0) {
      updatedFilters.push({field: "page", operator: "eq", value: page})
    } else {
      updatedFilters[pageIndex].value = page;
    }

    setFilters(updatedFilters);
  }

  if (tableQueryResult.isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs />
      {/* <div className="box-container">
        <Filter currentFilterValues={currentFilterValues} setFilters={setFilters} />
      </div> */}
      <div className="box-container">
        {!tableQueryResult.data?.data?.length &&
        !tableQueryResult.isFetching && (
          <div className="text-center">
            No data
          </div>
        )}

        {tableQueryResult?.data?.data && tableQueryResult?.data?.data.length > 0 ? (
          <>
            <div className="sm:hidden">
              <ConditionCard 
                data={tableQueryResult?.data?.data}
                pageSize={tableQueryResult?.data?.pageSize}
                currentPage={tableQueryResult?.data?.paging.current_page}
                _toggleActive={_toggleActive}
              />
            </div>
            <div className="hidden sm:block">
              <ConditionTable 
                data={tableQueryResult?.data?.data}
                pageSize={tableQueryResult?.data?.pageSize}
                currentPage={tableQueryResult?.data?.paging.current_page}
                _toggleActive={_toggleActive}
              />
            </div>
            <div className="mt-6">
              <Pagination 
                currentPage={tableQueryResult?.data?.paging.current_page}
                totalPage={tableQueryResult?.data?.paging.total_page}
                total={{
                  totalItems: tableQueryResult?.data?.paging.total_item || 0,
                  total: tableQueryResult?.data?.paging.total_item || 0
                }}
                onChange={_handlePageChanged}
              />
            </div>
          </>
        ) : <></>}
      </div>
      {(tableQueryResult.isFetching && tableQueryResult.isPreviousData) || updateMutationIsLoading ? <FullScreenLoading /> : <></>}
    </div>
  )
};